import { Stripe } from 'stripe'
import { useMemo } from 'react'
import format from 'date-fns/format'

const useGetBillingDate = (invoice: Stripe.Invoice): string => {
  return useMemo(() => {
    if (!invoice.lines.data[0]) return ''
    return format(new Date(invoice.lines.data[0].period.start * 1000), 'yyyy年M月ご請求分')
  }, [invoice])
}

export default useGetBillingDate
